import { render, staticRenderFns } from "./FourthStepContainer.vue?vue&type=template&id=f877708e&lang=html&"
import script from "./FourthStepContainer.vue?vue&type=script&lang=ts&"
export * from "./FourthStepContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports